<template>
  <div class="page">
    <List
      :loading="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div v-for="(item, index) in list" :key="index">
        <div class="list-item">
          <div class="items">
            <div class="product-img">
              <van-image
                fit="cover"
                width="100%"
                height="100%"
                :src="item.goods_thumb"
                alt=""
              />
            </div>
            <div>
              <p class="list-item-title">{{ item.title }}</p>
              <div class="num">￥{{ item.aoprice }}</div>
            </div>
          </div>
          <div class="list-item-state" @click="handleClick(item)">
            <div>立即抢单</div>
          </div>
        </div>
      </div>
    </List>
  </div>
</template>
<script>
import { List } from "vant";

export default {
  components: {
    List,
  },
  data() {
    return {
      loading: false,
      finished: false,
      list: [],
      page: 1,
      tid:''
    };
  },
  methods: {
    onLoad() {
      this.tid = this.$route.query.tid;
      this.getList();
      this.page++;
    },
    goto(item) {
      if (item.oid == 0) return;
      this.$router.push({ query: { item: item }, path: "commissionDetails" });
    },
    getList() {
      this.api.grabbingList({ page: this.page }).then((res) => {
        this.list = [...this.list, ...res.data.data];
        console.log(this.list);
        if (res.data.to < res.data.per_page) {
          this.loading = true;
          this.finished = true;
        } else {
          this.loading = false;
        }
      });
    },
    handleClick(item) {
      // console.log(item);
      this.Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      let id = item.id;
      this.api.grabbing({ id: id ,tid:this.tid}).then((res) => {
        console.log(res);
        this.Toast.clear()
        this.getList()
        this.Toast.success('抢单成功')
        setTimeout(() => {
          this.$router.push('twdorder')
        }, 1500);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.page {
  padding: 0.2rem;
}
.list-item {
  width: 100%;
  border-radius: 0.2rem;
  box-sizing: border-box;
  // margin: 0 0.24rem;
  padding: 0.32rem 0.2rem;
  margin-bottom: .2rem;
  background: #f6f6f6;
  .product-img {
    width: 0.9rem;
    height: 0.9rem;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 0.24rem;
  }
  .list-item-title {
    line-height: 1;
    font-weight: bold;
    font-size: 0.3rem;
    color: #666666;
    margin-bottom: 0.3rem;
  }
  .list-item-time {
    font-size: 0.24rem;
    font-weight: 400;
    color: #999999;
  }
  .items {
    display: flex;
    border-bottom: 1px solid #e3e3e3;
    width: 100%;
    padding-bottom: 0.33rem;
  }
  .list-item-state {
    text-align: right;
    font-size: 0.3rem;
    font-weight: 400;
    margin-top: 0.3rem;
    display: flex;
    justify-content: flex-end;
    div {
      width: 2rem;
      text-align: center;
      line-height: 0.66rem;
      color: #fff;
      height: 0.66rem;
      background: #34c290;
      border-radius: 0.33rem;
    }
  }
  .num {
    font-size: 0.34rem;
    font-weight: 400;
    line-height: 1;
    color: #f05468;
    font-weight: bold;
    margin-right: 0.12rem;
  }
  .list-item-more {
    i {
      font-size: 12px;
      color: #cccccc;
    }
  }
}
</style>
